module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('div', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('v-layout', {
    staticClass: "animated fadeInUp",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Actividad"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Actividad',
      "videoEmbed": "ADMINISTRACIONDINERO10Actividad  (ant41).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 200,
      "imaSrc": "design/banco4-3-2",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('p', [_vm._v("\n          ¿Qué decisiones adicionales puede tomar Juliana para estar más cerca de alcanzar su meta?"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Seleccione una decisión y arrástrela hasta la opción que corresponda:")])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInLeft dura_1",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md7": ""
    }
  }, [_c('div', {
    staticClass: "table-drop-act adorn-left"
  }, _vm._l((_vm.droppers), function(dropper, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('p', [_vm._v(" \n                " + _vm._s(_vm.listaDrop[index]) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": "",
        "text-xs-center": ""
      }
    }, [_c('draggable', {
      staticClass: "drop aligner",
      attrs: {
        "move": _vm.checkMove,
        "list": dropper,
        "options": {
          group: {
            name: 'opciones',
            pull: true,
            put: dropper.length < 1 ? true : false
          }
        }
      },
      model: {
        value: (dropper.name),
        callback: function($$v) {
          _vm.$set(dropper, "name", $$v)
        },
        expression: "dropper.name"
      }
    }, _vm._l((dropper), function(element, index) {
      return _c('div', {
        key: 'drop' + index
      }, [_c('p', {
        class: element.resp
      }, [_vm._v("\n                    " + _vm._s(element.name) + "\n                  ")])])
    }))], 1)], 1)
  }))]), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "text-xs-center": ""
    }
  }, [(_vm.retro) ? _c('div', {
    staticClass: "retro"
  }, [_vm._l((_vm.listOri), function(item, index) {
    return [(item.name === _vm.retro.name) ? _c('p', {
      key: index,
      staticClass: "animated fadeInUp font-red",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v(_vm._s(_vm.retro.retroalimientacion))]) : _vm._e()]
  }), _vm._v(" "), (_vm.retro === '¡Muy bien!') ? _c('p', {
    staticClass: "animated fadeInUp green",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.retro))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('draggable', {
    staticClass: "drag-container",
    attrs: {
      "move": _vm.checkMove,
      "options": {
        group: 'opciones'
      }
    },
    model: {
      value: (_vm.listDrag),
      callback: function($$v) {
        _vm.listDrag = $$v
      },
      expression: "listDrag"
    }
  }, _vm._l((_vm.listDrag), function(element) {
    return _c('div', {
      staticClass: "drag-elems back-red hvr-grow"
    }, [_vm._v("\n            " + _vm._s(element.name) + "\n          ")])
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600",
      "height": "200"
    },
    model: {
      value: (_vm.retroAct),
      callback: function($$v) {
        _vm.retroAct = $$v
      },
      expression: "retroAct"
    }
  }, [_c('v-card', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¡Muy bien!',
      "videoEmbed": "ADMINISTRACIONDINERO11Retroalimentacion (ant42).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 50,
      "imaSrc": "logos-icons/ok-bullet",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Para tomar decisiones efectivas y alcanzar las metas es importante saber administrar el dinero.\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('ui-button', {
    staticClass: "mt-2 mb-4",
    attrs: {
      "content": 'Cerrar',
      "aria": 'asdasd'
    },
    nativeOn: {
      "click": function($event) {
        _vm.retroAct = false
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('act-drag-back')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-557388bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-11.vue
// module id = 981
// module chunks = 1